export * from "./hant";
export * as hans from "./hans";
